import { SyncEventType } from '../../enums/syncEventType';
import { PersistenceEvent } from './persistenceEvent';

export class EventIssueOpened implements PersistenceEvent {

  public readonly type = SyncEventType.ISSUE_OPENED;
  public issueId: number;
  public avatar: string;

  constructor(issueId: number, avatar: string) {
    this.issueId = issueId;
    this.avatar = avatar;
  }

  getPayload(): object {
    return {
      'issueId': this.issueId,
      'avatar': this.avatar
    };
  }

  static fromPayload(payload: any): EventIssueOpened {
    return new EventIssueOpened(payload['issueId'], payload['avatar']);
  }

}

